module.exports = __webpack_public_path__ + "img/cashier.53e17b6e.png";